import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as recordLabAssignments from '../../record-lab-assignments'
import type { Collection } from '../collection'
import type { TypeParams } from '../types'

export const releaseSelectionOnModalClose = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    ec.models.CollectionProducer.getEc$<recordLabAssignments.TypeParams>(
      ec.Name.Predefined.SpaceLabAssignment,
      { waitUntilReady: true },
    ).pipe(
      rxjs.switchMap(labAssignmentsEc =>
        rxjs
          .merge(
            labAssignmentsEc.plugins.editingPlugin.feature.actions.discard.success.observe(),
            labAssignmentsEc.plugins.editingPlugin.feature.actions.submit.success.observe(),
            labAssignmentsEc.plugins.editingPlugin.feature.actions.submit.error.observe(),
          )
          .pipe(
            rxjs.map(action =>
              collection.plugins.selectionPlugin.applied.actions.putInSelectionLookup
                .from(action)
                .create({
                  key: labAssignmentsEc.associations?.selectionTarget,
                  value: { release: true },
                }),
            ),
          ),
      ),
    ),
)
